export default __webpack_public_path__ + "static/media/joaquin_randall.035716f9.png";